import { dasherize } from '@angular-devkit/core/src/utils/strings';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'dasherize',
})
export class DasherizePipe implements PipeTransform {
  transform(value: string): string {
    return dasherize(value);
  }
}
